import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { PlatformContext } from "../components/Platform/PlatformContext";
import logo from "../assets/white_trans_logo_ball_only.png";

const Footer: React.FC = () => {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  const renderLegalLinks = () => (
    <div className="flex space-x-6 justify-center md:justify-start">
      <Link to="/terms" className="hover:underline">
        AGB
      </Link>
      <Link to="/impressum" className="hover:underline">
        Impressum
      </Link>
      <Link to="/privacy" className="hover:underline">
        Datenschutzerklärung
      </Link>
    </div>
  );

  const renderSocialLinks = () => (
    <div className="flex space-x-6 justify-center md:justify-end">
      <a
        href="https://facultiesfootballleague.de"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center hover:underline"
      >
        <img
          src={logo}
          alt="Logo"
          className="w-10 h-10 transform transition-transform duration-200 hover:scale-110"
        />
      </a>

      <a
        href="https://www.instagram.com/ffl_tum/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center hover:underline"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
          className="w-10 h-10 transform transition-transform duration-200 hover:scale-110"
          aria-hidden="true"
        >
          <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5zM18 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM12 7.5a4.5 4.5 0 0 1 0 9 4.5 4.5 0 0 1 0-9zm0 1.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
        </svg>
      </a>

      {/* LinkedIn Logo */}
      <a
        href="https://www.linkedin.com/company/faculties-football-league/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center hover:underline"
      >
        {/* Standard LinkedIn-Icon-Pfad */}
        <svg
          role="img"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-10 h-10 transform transition-transform duration-200 hover:scale-110"
          aria-hidden="true"
        >
          <path
            d="M19 0h-14C2.238 0 0 2.238 0 5v14c0 2.762 2.238 5 5 
                   5h14c2.762 0 5-2.238 5-5V5c0-2.762-2.238-5-5-5zM7.119 
                   20.452H3.765V9h3.354v11.452zM5.442 7.507h-.022c-1.125 
                   0-1.854-.777-1.854-1.75 0-.996.75-1.75 
                   1.898-1.75 1.148 0 1.855.754 1.877 1.75 
                   0 .973-.73 1.75-1.899 1.75zM20.452 
                   20.452h-3.354v-5.62c0-1.413-.503-2.378-1.763-2.378-.96 
                   0-1.533.647-1.784 1.272-.092.22-.115.527-.115.834v5.892h-3.354s.044-9.552
                   0-10.552h3.354v1.495c.446-.688 1.244-1.668 
                   3.032-1.668 2.215 0 3.98 1.439 3.98 4.534v6.191z"
          />
        </svg>
      </a>
    </div>
  );

  const renderCTA = () => (
    <div className="flex justify-center">
      <Link
        to="/aboutus"
        className="px-8 py-3 border border-gray-50 bg-inherit hover:bg-gray-50 hover:text-black transition-colors rounded text-lg"
      >
        Meet the Team
      </Link>
    </div>
  );

  if (isDashboard) return null;

  return (
    <footer className="w-full border-t border-gray-500 text-white py-6">
      <div className="max-w-screen-lg mx-auto px-8">
        {isMobile ? (
          <div className="flex flex-col space-y-6">
            {renderCTA()}
            {renderSocialLinks()}
            {renderLegalLinks()}
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-4 items-center">
            <div>{renderLegalLinks()}</div>
            <div>{renderCTA()}</div>
            <div className="flex justify-end">{renderSocialLinks()}</div>
          </div>
        )}

        {/* Copyright */}
        <p className="mt-4 text-sm text-gray-400 text-center">
          © 2025 FFL. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
